import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../services/payment/payment.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { FrameworkSettingsTeleEye } from '../models/FrameworkSettingsTeleEye';

@Component({
  selector: 'app-framework-settings-teleeye',
  templateUrl: './framework-settings-teleeye.component.html',
  styleUrls: ['./framework-settings-teleeye.component.css']
})
export class FrameworkSettingsTeleeyeComponent implements OnInit {

  paymentGateway:Boolean=false;
  frameworkSettings:FrameworkSettingsTeleEye;
  constructor(public paymentService:PaymentService,public foruscareService:ForuscareService) { }

  ngOnInit() {
    this.frameworkSettings = new FrameworkSettingsTeleEye();
    this.getFrameworkSettings();
    
  }
  save() {
    var requestObj = [];
    this.frameworkSettings.PAYMENT_GATEWAY = (this.paymentGateway == true? "PAYUMONEY": "RAZORPAY");
    for(var t in this.frameworkSettings){
      requestObj.push({"type":t,"value":this.frameworkSettings[t]});
    }
    this.paymentService.saveFrameworkSettingsByApplication(requestObj,"FH_TELE_EYE")
      .subscribe(response => {
        if (response.errorCode == 200) {
          this.foruscareService.showNotification("Settings updated", "success");
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }
  getFrameworkSettings(){
    this.paymentService.getFrameworkSettingsByApplication("FH_TELE_EYE")
    .subscribe(response=>{
      if(response.errorCode == 200 && response.data!=null){
        response.data.forEach(element => {
          this.frameworkSettings[element.type] = element.value;
          if(element.type=="PAYMENT_GATEWAY"){
            this.paymentGateway = element.value=="PAYUMONEY"?true:false;
          }
        });
      }
      else{
        this.foruscareService.showNotification("No data found", "danger");
      }
    })
  }

}
